import { createContext } from "react";

import { StorageManager } from "./storageManager";

export const StorageManagerContext = createContext(new StorageManager());
